import {call, put, takeLatest} from 'redux-saga/effects'

import * as report from '../../report'
import * as showroomsDirectoryActions from '../../actions/showrooms/directory'
import {getShowroomLocations} from '../../api/showrooms'
import {isBadResponse} from '../../api/statusCodes'

/**
 * Retrieve all showroom locations
 * @generator
 */
export function* getAllLocationsWorker() {
  yield put(showroomsDirectoryActions.getAllLocationsPending())

  try {
    const {json, status} = yield call(getShowroomLocations)
    if (isBadResponse(status)) {
      throw new Error('Unable to fetch showroom locations')
    }
    yield put(showroomsDirectoryActions.getAllLocationsSuccess(json))
  } catch (error) {
    report.exception(error)
    yield put(showroomsDirectoryActions.getAllLocationsFailure(error))
  }
}

export function* getAllLocationsSaga() {
  yield takeLatest(showroomsDirectoryActions.GET_ALL_LOCATIONS, getAllLocationsWorker)
}
